import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorBirthDateRawFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorBirthDateRawField: FC<CryptorBirthDateRawFieldProps> = ({
  control,
}) => (
  <Controller
    control={control}
    name="birthDateRaw"
    render={({ field, fieldState }) => (
      <TextField
        InputLabelProps={{ shrink: true }}
        type="text"
        label="Date de naissance"
        name="placeOfBirthRaw"
        value={field.value}
        onChange={field.onChange}
        margin="normal"
        error={fieldState.invalid}
      />
    )}
  />
);

export default CryptorBirthDateRawField;
